module.exports = __webpack_public_path__ + "static/media/facebook-light-filled.3dabe0af.svg";